import { setupFaro } from './faro';
import { setupSentry } from './sentry';

export async function setupMonitoring(): Promise<void> {
    await setupFaro();
    if (process.env.NODE_ENV === 'production') {
        setupSentry();
    }
}
